import { logger } from '@talos/kyoko';
import type React from 'react';
import { Component, type ErrorInfo } from 'react';
import { ErrorBoundaryDisplay } from './ErrorBoundaryDisplay';

export class ErrorBoundary extends Component<
  React.PropsWithChildren<{ message?: string; minimal?: boolean }>,
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // https://docs.datadoghq.com/real_user_monitoring/browser/collecting_browser_errors/?tab=npm#react-error-boundaries-instrumentation
    const renderingError = new Error(error.message);
    renderingError.name = `ReactRenderingError`;
    renderingError.stack = info.componentStack;
    renderingError.cause = error;
    logger.error(error);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryDisplay {...this.props} />;
    }

    return this.props.children;
  }
}
